import React from 'react'
import SEO from '../../components/seo'
import {graphql, StaticQuery} from "gatsby";
import LinkMaintainEmbedded from "../../components/LinkMaintainEmbedded";
const formatter = require('../../../utilities/formatter');

const ArticlesPageComponent = ({ embedded,  webViewVersion }) => {

  return(
    <StaticQuery
      query={graphql`
        query ArticlesQuery {
          allStrapiArticle {
            edges {
              node {
                id
                Title
                Public
              }
            }
          }
        }
      `}
      render={data => {
        return (
          <div>
            <SEO title="Camping" description="Articles to help you camp safer, smarter, and with more comfort and fun"/>
            {!embedded ? <h1>Camping</h1> : null}
            <ul>
              {data.allStrapiArticle.edges.map(document => {
                if (document.node.Public === true) {
                  return (
                    <li key={document.node.id}>
                      <LinkMaintainEmbedded to={`/article/${formatter.urlFriendlyTitle(document.node.Title)}`} embedded={embedded} webViewVersion={webViewVersion}>
                        {document.node.Title}
                      </LinkMaintainEmbedded>
                    </li>
                  )
                } else {
                  return null
                }
              })}
            </ul>
          </div>
        )
      }} />
  )
}

export default ArticlesPageComponent